import IframeServiceInjector from '../injectors/IframeServiceInjector';

export default abstract class IframeService {
  abstract injectIframe(iframe: HTMLIFrameElement): void;

  constructor(name: string, persistant = false) {
    if (new.target === IframeService) {
      throw new TypeError('Cannot construct abstract instances directly');
    }

    if (IframeServiceInjector.getService(name)) {
      return;
    }

    IframeServiceInjector.addService(this, name, persistant);
  }
}
